import clsx from 'clsx';
import React from 'react';

import LazyImgixImage from '@components/LazyImgixImage';
import { IMGIX_URL } from '@src/env';

export const THE_INFORMATION_HEADER = `${IMGIX_URL}/global/subscribe/the_information_header.png`;
export const GIFT_SUBSCRIPTION_HEADER = `${IMGIX_URL}/global/gift/gift_subscription_header.gif`;

interface HeaderProps {
  isGiftLanding?: boolean;
}

const Header = ({ isGiftLanding }: HeaderProps) => {
  const headerDetails = isGiftLanding
    ? {
        header: 'Give the gift of',
        subheader:
          'More than a gift—an advantage. Share the exclusive reporting that shapes how ambitious people think, work and win.',
        imageSrc: GIFT_SUBSCRIPTION_HEADER,
      }
    : {
        subheader:
          'A global publication committed to original reporting and in-depth analysis of tech, finance and media industries.',
        imageSrc: THE_INFORMATION_HEADER,
      };
  const { header, subheader, imageSrc } = headerDetails;
  return (
    <section
      className={clsx('flex flex-row items-center gap-8 sm:gap-16 lg:gap-72', {
        'flex-wrap px-0 text-center sm:flex-nowrap sm:px-24 sm:text-left lg:px-0': isGiftLanding,
        'md:px-40': !isGiftLanding,
      })}
    >
      <div>
        {header && (
          <span
            className={clsx(
              'font-suisse-screen text-headline-xxs text-primary-magenta md:text-headline-alt-md'
            )}
          >
            {header}
          </span>
        )}
        <h1
          className={clsx('m-0 font-suisse-works text-black', {
            'text-headline-alt-md sm:text-headline-alt-md md:text-headline-alt-lg': isGiftLanding,
            'text-headline-xs sm:text-headline-lg md:text-headline-lg': !isGiftLanding,
          })}
        >
          The Information
        </h1>
        <p
          className={clsx('mb-0 mt-8 font-suisse-neue text-grayscale-charcoal', {
            'font-suisse-intl text-overline-lg': isGiftLanding,
            'text-body-md sm:text-subheadline-sm': !isGiftLanding,
          })}
        >
          {subheader}
        </p>
      </div>
      <LazyImgixImage
        alt="The Information Header"
        className={clsx({
          'mt-20 max-w-full sm:my-0 sm:block sm:max-w-[380px] md:max-w-[480px]': isGiftLanding,
          'hidden sm:block sm:max-w-[290px] md:max-w-[307px]': !isGiftLanding,
        })}
        src={imageSrc}
        sizes={clsx({
          '(min-width: 1200px) 600px, (min-width: 992px) 400px, 300px': !isGiftLanding,
        })}
        wrapperClassName={clsx({
          'min-w-full sm:min-w-[380px] md:min-w-[480px]': isGiftLanding,
          'sm:min-w-[290px] sm:min-h-[170px] md:min-w-[307px] md:min-h-[180px]': !isGiftLanding,
        })}
      />
    </section>
  );
};

export default Header;
